import axios from "axios";

let baseUrl = process.env.VUE_APP_ROOT_API;
class portalAPI {
  constructor() {}

  getUserMenus() {
    return axios.get(`${baseUrl}/userMenus/`);
  }

  navigateTo(maskedUrl) {
    return axios.get(`${baseUrl}/${maskedUrl}`);
  }

  saveMessage(message) {
    //ToDo: add validation
    return axios.post(`${baseUrl}/Messages/`, message);
  }

  saveMessageReciever(messageReciever) {
    //ToDo: add validation
    return axios.post(`${baseUrl}/MessagesReciever/`, messageReciever);
  }

  getMessageRecieverSettings() {
    return axios.get(`${baseUrl}/MessagesRecieverSettings/`);
  }

  getMessageSenderSettings(nodeId, msgType) {
    let config = {
      params: {
        nodeId: nodeId,
        msgType: msgType
      }
    };
    return axios.get(`${baseUrl}/MessagesSenderSettings/`, config);
  }

  getUserPages() {
    return axios.get(`${baseUrl}/pages/`);
  }

  getUserNodes() {
    return axios.get(`${baseUrl}/userNodes/`);
  }
  
  AddEvent(event) {
    return axios.post(`${baseUrl}/Workspace/AddEvent/`, event);
  }
}

export default portalAPI;
